import consts from '@/consts'
import local from '@/local'
import { WS } from 'shared'
import logger from '@/services/logger'

const wsApp = new WS('api', logger, consts.agent)
wsApp.setBaseURL({
  domain: local.domain,
  subdomain: 'api'
})

const wsEvent = new WS('event', logger, consts.agent)

export {
  wsApp,
  wsEvent
}
